export default "__VITE_ASSET__C$Gua1cZ__"